// extracted by mini-css-extract-plugin
export default {"title":"Eligibility_title__Dbhx9","description":"Eligibility_description__orY5M","loading":"Eligibility_loading__SknHr"};